<template>
    <!-- Navigation -->
    <nav class="navbar navigation navbar-expand-lg">
        <div class="container">

            <!-- Brand -->
            <a class="navbar-brand" href="#">
                <img src="assets/images/logo/logo.svg" alt="">
            </a>

            <!-- Toggler -->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <!-- Navigation Content -->
            <div class="collapse navbar-collapse" id="navbarContent">
                <div class="navbar-content">
                    <ul class="navbar-nav">
                        <li class="nav-item active">
                            <a class="nav-link" href="#">Početna</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#" role="button" data-toggle="dropdown" data-target="dropdown1" aria-haspopup="true" aria-expanded="false">O časopisu<span class="caret"></span></a>
                            <div id="dropdown1" class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item" href="#">O nama</a>
                                <a class="dropdown-item" href="#">Prilozi</a>
                                <a class="dropdown-item" href="#">Poziv na suradnju</a>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">Arhiva</a>
                        </li>
                    </ul>
                    <div class="additional">
                        <div class="search">
                            <form class="form-inline">
                                <input class="form-control search-control" type="search" placeholder="Pretaživanje..." aria-label="Pretaživanje...">
                            </form>
                        </div>
                        <div class="languages">
                            <a href="#">HR</a>
                            <a href="#">EN</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </nav>
</template>

<script>
    /* Mixins */
    import { Default } from '@mixins/Default'

    /* Components */
    import Languages from '@components/App/Partials/Languages'

    /* Logic */
    export default {
        name: "Navigation",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'navigation',
            'snippets',
            'slugs',
            'translatable',
        ],
        components: {
            'Languages': Languages
        },
        data: function () {
            return {
                main: '',
                bottom: '',
                both: '',
                shop: '',
                toggle: false
            }
        },
        methods: {
            fetchItems: function () {
                this.main = this.navigation.main
                this.bottom = this.navigation.bottom
                this.both = this.navigation.both
                this.shop = this.navigation.shop
            },
            toggleNavigation: function (event) {
                this.toggle === true ? $('body').removeClass('overflow-hidden') : this.toggle = $('body').addClass('overflow-hidden')
                this.toggle === true ? this.toggle = false : this.toggle = true
                event.preventDefault()
            }
        },
        watch: {
            locality: function () {
                this.initialize()
                this.fetchItems()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Languages.vue